import {
    FETCH_SUB_AGREEMENT_LIST_REQUEST,
    FETCH_SUB_AGREEMENT_LIST_SUCCESS,
    FETCH_SUB_AGREEMENT_LIST_FAILURE,

    CREATE_SUB_AGREEMENT_REQUEST,
    CREATE_SUB_AGREEMENT_SUCCESS,
    CREATE_SUB_AGREEMENT_FAILURE,

    UPDATE_SUB_AGREEMENT_REQUEST,
    UPDATE_SUB_AGREEMENT_SUCCESS,
    UPDATE_SUB_AGREEMENT_FAILURE
} from './types';


/**
 *
 * @param {Object} [params]
 * @returns
 */
 export const fetchSubAgreementListRequest = (params) => ({
    type: FETCH_SUB_AGREEMENT_LIST_REQUEST,
    payload: params
});

/**
 *
 * @param {ListState} data
 * @returns
 */
export const fetchSubAgreementListSuccess = (data) => ({
    type: FETCH_SUB_AGREEMENT_LIST_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function fetchSubAgreementListFailure(error) {
    return {
        type: FETCH_SUB_AGREEMENT_LIST_FAILURE,
        error
    };
}




/**
 *
 * @param {Object} [params]
 * @returns
 */
 export const createSubAgreementRequest = (params) => ({
    type: CREATE_SUB_AGREEMENT_REQUEST,
    payload: params
});

export const createSubAgreementSuccess = (data) => ({
    type: CREATE_SUB_AGREEMENT_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function createSubAgreementFailure(error) {
    return {
        type: CREATE_SUB_AGREEMENT_FAILURE,
        error
    };
}



/**
 *
 * @param {SubAgreement} params
 * @returns
 */
 export const updateSubAgreementRequest = (params) => ({
    type: UPDATE_SUB_AGREEMENT_REQUEST,
    payload: params
});

export const updateSubAgreementSuccess = (data) => ({
    type: UPDATE_SUB_AGREEMENT_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function updateSubAgreementFailure(error) {
    return {
        type: UPDATE_SUB_AGREEMENT_FAILURE,
        error
    };
}
